import { Text } from '@chakra-ui/react'

type HighlightTextProps = {
  text: string
  text_color?: string
  text_size?: string
  text_highlight_color?: string
  keywords: string[]
  onKeywordClick: (key: string) => void
}

export default function HighlightText(props: HighlightTextProps) {
  const { text, keywords, onKeywordClick, text_highlight_color = 'text_highlight', text_size = '12px', text_color = 'primary_gray' } = props

  const keywordRegex = new RegExp(`(${keywords.join('|')})`, 'gi')
  const parts = text.split(keywordRegex)

  return (
    <Text display="inline" whiteSpace="normal" as="span" textAlign="start">
      {parts.map((part, index) => {
        if (keywords.includes(part)) {
          return (
            <Text
              lineHeight="20px"
              key={index}
              fontSize={text_size}
              color={text_highlight_color}
              cursor="pointer"
              onClick={() => onKeywordClick(part)}
              whiteSpace="inherit"
              as="span"
            >
              {part}
            </Text>
          )
        }
        return (
          <Text
            lineHeight="20px"
            key={index}
            fontSize={text_size}
            color={text_color}
            cursor="pointer"
            onClick={() => onKeywordClick(part)}
            whiteSpace="inherit"
            as="span"
          >
            {part}
          </Text>
        )
      })}
    </Text>
  )
}
